// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__5HdhW","rightAdornment":"Header_rightAdornment__RYAx_"};